import * as React from 'react'
import {
  List,
  TextField,
  FunctionField,
  DatagridConfigurable,
  TopToolbar,
  SelectColumnsButton,
  FilterButton,
  TextInput,
  ReferenceInput,
  SelectInput,
  Link,
} from 'react-admin'

/**
 * Notifications Log
 *
 * Read-only audit trail of provider changes, written by
 * mfh-util/providerChangeLog from the endpoints that mutate a Provider.
 * One row per changed field.
 */
const ProviderNotificationLogList = (props) => {
  const filters = [
    <TextInput label="User" source="user" alwaysOn />,
    <ReferenceInput source="providerId" reference="providers" alwaysOn>
      <SelectInput optionText={'displayName'} emptyText={'All'} />
    </ReferenceInput>,
    <TextInput label="Field" source="field" />,
  ]

  return (
    <List
      {...props}
      title="Notifications Log"
      actions={
        <TopToolbar>
          <FilterButton />
          <SelectColumnsButton />
        </TopToolbar>
      }
      filters={filters}
      // logIds embed a UTC timestamp, so descending is reverse-chronological.
      filter={{ _order: 'DESC' }}
    >
      <DatagridConfigurable bulkActionButtons={<></>}>
        <FunctionField
          label="Date"
          render={(record) => (record.createdAt ? new Date(record.createdAt).toLocaleString() : '')}
        />
        <TextField source="action" label="Action" />
        <FunctionField
          label="Provider"
          render={(record) =>
            record.providerId ? (
              <Link to={`/providers/${record.providerId}/show`}>{record.providerName || record.providerId}</Link>
            ) : (
              '—'
            )
          }
        />
        <TextField source="user" label="User" />
        <TextField source="field" label="Field" />
        <TextField source="oldValue" label="Previous Value" />
        <TextField source="newValue" label="New Value" />
      </DatagridConfigurable>
    </List>
  )
}

export default ProviderNotificationLogList
